import React, { ReactElement } from "react"
import GuestAvatar from "components/elements/GuestAvatar"
import { DioboxEvent, Guest, ModalName } from "sharedTypes"
import { Link } from "react-router-dom"
import Icon from "components/elements/Icon"
import WhatsAppIcon from "components/elements/WhatsAppIcon"
import {
  Box, Flex, Heading, Text,
} from "@chakra-ui/react"
import { useEventGuestPaths } from "utilities/routes"
import useModal from "services/useModal"
import GuestMenu from "../Menu"

type Props = {
  guest: Guest
  event: DioboxEvent
  displayMenu?: boolean
}

const Header = ({ guest, event, displayMenu }: Props) => {
  const { eventGuestPath } = useEventGuestPaths()
  const showModal = useModal()
  const {
    id,
    eventId,
    personInfo: {
      firstName,
      lastName,
      photoUrl,
      companyName,
      companyTitle,
      unsubscribed,
      optedInWhatsapp,
    },
    notifications,
  } = guest

  const openCommunicationPreferences = () => {
    showModal(ModalName.GuestCommunicationPreferences, { guest })
  }

  const wrapClickable = (icon: ReactElement) => (
    displayMenu
      ? <Box as="button" type="button" onClick={openCommunicationPreferences} aria-label="Open communication preferences">{icon}</Box>
      : icon
  )

  const emailUnsubscribedIcon = () => {
    if (!unsubscribed) { return null }

    return wrapClickable(
      <Icon icon="guest-unsubscribed" size={5} ml={2} cursor={displayMenu ? "pointer" : ""} />,
    )
  }

  const whatsappOptedInIcon = () => {
    if (!optedInWhatsapp) { return null }

    return wrapClickable(
      <WhatsAppIcon size={5} ml={2} color="whatsapp.500" cursor={displayMenu ? "pointer" : ""} />,
    )
  }

  const checkInAlert = () => {
    if (notifications.length === 0) { return null }

    const icon = <Icon icon="checkin-alert" size={5} ml={2} color="blue.500" />

    return displayMenu ? <Link to={`${eventGuestPath(eventId, id)}/check-in-alert`}>{icon}</Link> : icon
  }

  return (
    <>
      <Flex mb={4} pos="relative" zIndex="1" align="top" justify="center">
        <GuestAvatar
          firstName={firstName}
          lastName={lastName}
          photoUrl={photoUrl}
          status={guest.status}
          checkedIn={guest.checkedIn > 0}
          size={32}
        />
        {(displayMenu) && (
        <Box pos="absolute" right={0}>
          <GuestMenu guest={guest} event={event} />
        </Box>
        )}
      </Flex>
      <Box textAlign="center" mb={6}>
        <Flex align="center" justify="center">
          <Heading fontSize="2xl">{firstName} {lastName}</Heading>
          {emailUnsubscribedIcon()}
          {whatsappOptedInIcon()}
          {checkInAlert()}
        </Flex>
        { companyName && <Text>{ companyName }</Text> }
        { companyTitle && <Text>{ companyTitle }</Text> }
      </Box>
    </>
  )
}

export default Header
